import styled from '@emotion/styled'
import { FiBell, FiChevronRight } from 'react-icons/fi'

export const DropdownContainer = styled.div`
  width: 380px;
  max-height: 500px;
  overflow-y: auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  padding: 16px 0;
  z-index: 1000;
  border: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    width: 90vw;
    max-height: 80vh;
    padding: 12px 0;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 8px 16px;

  @media (max-width: 768px) {
    padding: 0 12px 6px 12px;
  }
`

export const Title = styled.div`
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: #2d3748;
  gap: 8px;

  @media (max-width: 768px) {
    font-size: 14px;
    gap: 6px;
  }
`

export const BellIcon = styled(FiBell)`
  color: #4a5568;
  width: 18px;
  height: 18px;

  @media (max-width: 768px) {
    width: 16px;
    height: 16px;
  }
`

export const ChevronIcon = styled(FiChevronRight)`
  margin-left: 4px;

  @media (max-width: 768px) {
    margin-left: 2px;
  }
`

export const ViewAll = styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #4a5568;
  cursor: pointer;
  transition: color 0.2s;

  &:hover {
    color: #3182ce;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }
`

export const UnreadCount = styled.div`
  background: #3182ce;
  color: white;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: 6px;

  @media (max-width: 768px) {
    font-size: 10px;
    padding: 1px 4px;
    margin-left: 4px;
  }
`

export const Divider = styled.div`
  height: 1px;
  background: #edf2f7;
  margin: 8px 0;

  @media (max-width: 768px) {
    margin: 6px 0;
  }
`

export const Empty = styled.div`
  text-align: center;
  padding: 32px 0;
  font-size: 14px;
  color: #718096;

  & > div {
    margin-top: 12px;
    font-weight: 500;
  }

  @media (max-width: 768px) {
    padding: 20px 0;
    font-size: 13px;
    & > div {
      margin-top: 8px;
    }
  }
`

export const EmptyIcon = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto;
  background: #f7fafc;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cbd5e0;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }
`

export const EmptySubtext = styled.div`
  font-size: 13px;
  color: #a0aec0;
  margin-top: 4px;

  @media (max-width: 768px) {
    font-size: 12px;
    margin-top: 2px;
  }
`

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
`

export const Item = styled.li<{ unread?: boolean }>`
  padding: 12px 16px;
  border-left: 3px solid ${({ unread }) => (unread ? '#3182ce' : 'transparent')};
  background: ${({ unread }) => (unread ? '#f8fbff' : 'white')};
  transition: background 0.2s;
  cursor: pointer;

  &:hover {
    background: #f7fafc;
  }

  & + & {
    border-top: 1px solid #edf2f7;
  }

  @media (max-width: 768px) {
    padding: 10px 12px;
  }
`

export const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
  position: relative;
`

export const ItemTitle = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #2d3748;
  padding-right: 16px;

  @media (max-width: 768px) {
    font-size: 13px;
    padding-right: 12px;
  }
`

export const ItemTime = styled.div`
  font-size: 12px;
  color: #a0aec0;
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 11px;
  }
`

export const UnreadBadge = styled.div`
  position: absolute;
  left: -10px;
  top: 6px;
  width: 8px;
  height: 8px;
  background: #3182ce;
  border-radius: 50%;

  @media (max-width: 768px) {
    left: -8px;
    top: 4px;
    width: 6px;
    height: 6px;
  }
`

export const ItemBody = styled.div`
  font-size: 13px;
  color: #4a5568;
  line-height: 1.4;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    font-size: 12px;
    margin-bottom: 6px;
  }
`

export const ItemFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ItemDate = styled.div`
  font-size: 12px;
  color: #a0aec0;

  @media (max-width: 768px) {
    font-size: 11px;
  }
`

export const MarkReadButton = styled.button`
  background: none;
  border: none;
  color: #cbd5e0;
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    color: #718096;
    background: #edf2f7;
  }

  @media (max-width: 768px) {
    padding: 1px;
  }
`
